export default __webpack_public_path__ + "static/media/moss-icon-small__rgb.bbb327ff.svg";